// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"2c542bea","486":"00006c74","614":"1522c499","679":"ecff2c71"}[chunkId] + ".chunk.css";
};